<template>
  <div class="container">
    <div class="top">
      <p class="title" @click="tohome">全国系统集成资质查询系统</p>
      <div class="search">
        <el-input
          placeholder="请输入企业全称、人员姓名或证书(人员)编号"
          v-model="searchTxt"
        ></el-input>
        <span @click="getdata(searchTxt)">查询</span>
      </div>
    </div>
    <div class="search-page">
      <div class="result">
        <div class="result-header">集成企业资质</div>
        <div class="company" v-if="enterpriseShow">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>企业名称</th>
                <th>证书编号</th>
                <th>证书名称</th>
                <th>有效期</th>
                <th>类别</th>
                <th>发证机关</th>
                <th>资质等级</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in enterpriseData" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.enterpriseName }}</td>
                <td>{{ item.certificateNo }}</td>
                <td>{{ item.creditName }}</td>
                <td>{{ item.effectiveDate }}</td>
                <td>{{ item.cwName }}</td>
                <td>{{ item.organName }}</td>
                <td>{{ item.rating }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="seperate-line"></div>
      <div class="result">
        <div class="result-header">专业人员资格</div>
        <div class="manager" v-if="personShow">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>姓名</th>
                <th>企业名称</th>
                <th>登记编号</th>
                <th>证书名称</th>
                <th>有效期</th>
                <th>证书类别</th>
                <th>发证机关</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in personData" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.enterpriseName }}</td>
                <td>{{ item.certificateNo }}</td>
                <td>{{ item.qualificationName }}</td>
                <td>{{ item.effectiveDate }}</td>
                <td>{{ item.rating }}</td>
                <td>{{ item.organName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="footer">
        <a href="http://www.beian.miit.gov.cn" target="_blank"
          >浙ICP备17042384号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      enterpriseData: [],
      personData: [],
      enterpriseShow: false,
      personShow: false,
      searchTxt: "",
    };
  },
  methods: {
    getdata(name) {
      var keyword;
      if (name) {
        keyword = name;
        this.$router.replace({ path: "/result", query: { search: keyword } });
      } else {
        keyword = this.$route.query.search;
      }
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL +
          "/query/xtjccx?EnterpriseName=" +
          keyword,
      }).then((response) => {
        if (response.data.status === 0) {
          this.enterpriseData = response.data.data.enterpriseData;
          this.personData = response.data.data.personData;
          if (response.data.data.enterpriseData.length > 0) {
            this.enterpriseShow = true;
          } else {
            this.enterpriseShow = false;
          }
          if (response.data.data.personData.length > 0) {
            this.personShow = true;
          } else {
            this.personShow = false;
          }
        }
      });
    },
    tohome() {
      this.$router.push("/");
    },
  },
  mounted() {
    this.getdata();
    this.searchTxt = this.$route.query.search;
  },
};
</script>

<style lang="scss" scoped>
.container {
  color: #2c3e50;
  height: 100%;
  max-width: 1440px;
  min-width: 960px;
  margin: 0 auto;
}
.top {
  padding: 0 220px;
  height: 70px;
  .title {
    color: #fe5c04;
    font-size: 26px;
    letter-spacing: 4px;
    line-height: 70px;
    cursor: pointer;
    float: left;
  }
  .search {
    float: right;
    position: relative;
    width: 360px;
    margin: 20px 0;
    height: 30px;
    span {
      display: inline-block;
      color: #fff;
      height: 30px;
      line-height: 30px;
      background: #fe5c04 url("../assets/images/search.png") no-repeat 10px 50%;
      background-size: 16px;
      width: 80px;
      border-radius: 30px;
      position: absolute;
      right: 0;
      bottom: 0;
      padding-left: 30px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
  .el-input {
    width: 90%;
    text-align: left;
    height: 26px;
    line-height: 26px;
    border: 2px solid #fe5c04;
    border-radius: 30px;
  }

  /deep/.el-input__inner {
    line-height: 26px;
    height: 26px;
    border-radius: 30px;
    border: 0;
    outline: 0;
    font-size: 12px;
    color: #333;
  }
}

.search-page {
  width: 100%;
  background: #f7f7f7;
  overflow: hidden;
  border-top: 1px solid #fe5c04;
  padding-bottom: 30px;
}
.result {
  width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.result table {
  margin-top: 20px;
  border: 1px solid #e9e9e9;
  border-collapse: collapse;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #666;
}
.result table td,
.result table th {
  border: 1px solid #e9e9e9;
  padding: 5px;
  height: 54px;
}
.result table th {
  border-bottom-width: 2px;
  text-align: center;
}
.result table tr {
  background-color: #f7f7f7;
}
.result table tbody tr:nth-of-type(odd) {
  background-color: #fff;
}
.result-header {
  border-left: 2px solid #fe5c05;
  text-align: left;
  font-size: 16px;
  color: #fe5c05;
  padding-left: 10px;
  margin-top: 20px;
}
.seperate-line {
  border-top: 1px solid #e9e9e9;
  width: 100%;
}
.footer {
  border-top: 2px solid #fe5c05;
  text-align: center;
  line-height: 50px;
}
</style>
